import { styled } from '~/styled'

export const TreeList = styled('ul', {
  base: ['flex', 'flex-col', 'p-0', 'm-0', 'list-none', 'w-full', '[&_&]:pl-4']
})
